import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Redirect } from 'react-router-dom';
import useUserContext from './providers/User/UserProvider';
import { signUpSignInRequest } from './authConfig';
import LoadingRenderer from './components/Common/LoadingRenderer';
import { getMsalInstance } from './auth';
import { useContext } from 'react';
import { AuthErrorContext } from '.';
import { getRuntimeConfig } from './config/runtimeConfig';

const Login = () => {
  const { isAuthenticated, isLoadingUser } = useUserContext();
  const { error, setError } = useContext(AuthErrorContext);

  const handleLogin = () => {
    try {
      setError('');
      const msalInstance = getMsalInstance();
      const cfg = getRuntimeConfig();
      msalInstance.loginRedirect(signUpSignInRequest(cfg));
    } catch (error) {
      console.log(error);
    }
  };

  if (isAuthenticated) {
    const redirect = localStorage.getItem('redirect');
    localStorage.removeItem('redirect');
    const redirectTo = redirect ? redirect : '/hinnastot';
    return <Redirect to={redirectTo} />;
  }
  if (isLoadingUser) {
    return (
      <Container
        maxWidth={false}
        sx={{
          '--spacing': '2rem',
          backgroundColor: 'white',
          borderRadius: 2,
          my: 'var(--spacing)',
          p: 'var(--spacing)',
          width: 'calc(100% - var(--spacing) * 2)',
          paddingBottom: 80,
        }}
      >
        <LoadingRenderer
          label={'Ohjataan käyttäjää...'}
          sx={{ my: 2, mt: 30 }}
        />
      </Container>
    );
  }

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          paddingTop: 4,
          paddingBottom: 2,
          marginTop: 8,
        }}
      >
        <Box display="flex" p={2}>
          <Box
            flex={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              width={80}
              src={'/rami-waiting.png'}
              alt="Waiting icon"
            />
          </Box>

          <Box
            flex={2}
            display="flex"
            flexDirection="column"
            gap={2}
            pl={2}
          >
            <Box
              flex={1}
              display="flex"
              justifyContent="left"
              alignItems="left"
            >
              <Typography
                variant="h4"
                component="div"
                gutterBottom
                color="primary"
              >
                Kirjaudu sisään
              </Typography>
            </Box>
            <Box
              flex={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography>
                Tervetuloa hinnasto- ja tarjoustyökaluun. Aloita
                kirjautumalla sisään
              </Typography>
            </Box>
            <Box
              flex={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 3 }}
                onClick={handleLogin}
              >
                Kirjaudu
              </Button>
            </Box>
            <Box>
              {error && (
                <Typography variant="body1" color={'red'}>
                  {error}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Login;
